/**
* resources slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the resources slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'resources-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.resource-slider' ).slick( {
        autoplay: false,
        arrows: true,
        centerPadding: '60px',
        variableWidth: true,
        prevArrow: $( '.resources-slider-previous' ),
        nextArrow: $( '.resources-slider-next' ),
        slidesToScroll: 1,
        slidesToShow: 3,
        infinite: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              dots: false,
              centerPadding: '0px',
              slidesToShow: 1,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'resources-slider', COMPONENT );
} )( app );
